import Box from "@/common/components/Box";
import Button from "@/common/components/Button";
import TextField from "@/common/components/TextField";
import { Link, useParams } from "react-router-dom";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import TextArea from "@/common/components/TextArea";
import useTmaisPermission from "../../hooks/useTmaisPermission";
import { ShowHeader } from "@/common/components/ShowHeader";

const Show = () => {
  const { id } = useParams();

  const {
    data: initialTmaisPermission,
    isPending: initialTmaisPermissionIsPending,
    error: initialTmaisPermissionError = {} as any,
    refetch: refetchTmaisPermission,
  } = useTmaisPermission(id || '');

  const disableUpdateButton = initialTmaisPermissionIsPending || initialTmaisPermissionError?.status === 403;

  return (
    <div>
      <ShowHeader
        title="Permissões - Tmais"
        subtitle={initialTmaisPermission?.display_name}
        goBack
        goBackProps={{
          fallback: '/tmais-permissions',
          searchLastRouteFromFallback: true
        }}
        buttons={(
          <Link
            to={disableUpdateButton ? '' : `/tmais-permissions/${id}/edit`}
            className={disableUpdateButton ? "cursor-default" : ''}
          >
            <Button operationKlassToCheckPermission="Admin::Tmais::Permissions::Update" data-testid='update_tmais_permission_button' type="submit" className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]" disabled={disableUpdateButton}>
              Editar
            </Button>
          </Link>
        )}
      />

      {initialTmaisPermissionIsPending ? (
        <Box>Carregando...</Box>
      ) : (
        <ErrorMessageWrapper
          className="max-h-[calc(100vh-128px)]"
          statusCode={initialTmaisPermissionError?.status}
          refetchFunction={refetchTmaisPermission}
        >
          <Box className="flex flex-col gap-4 shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]">
            <p className="text-lg font-bold">
              {initialTmaisPermission?.display_name}
            </p>

            <div className="flex gap-2">
              <TextField
                label="Nome"
                value={initialTmaisPermission?.display_name}
                data-testid="display_name_input"
                className="w-1/2"
                disabled
              />
              <TextField
                label="Classe de operação"
                value={initialTmaisPermission?.operation_klass}
                data-testid="operation_klass_input"
                className="w-1/2"
                disabled
              />
            </div>

            <TextField
              label="Descrição"
              value={initialTmaisPermission?.description}
              data-testid="description_input"
              disabled
            />

            <TextArea
              label="Propiedades"
              placeholder="{}"
              value={JSON.stringify(initialTmaisPermission?.properties, null, 4)}
              rows={8}
              disabled
            />
          </Box>
        </ErrorMessageWrapper>
      )}

    </div>
  );
};

export default Show;
